export default "__VITE_ASSET__C_htMw1___"